export * from './details-panel'
export type { Props as DetailsPanelProps } from './details-panel.types'
